<template>
  <Badge
    :status="status"
  >
    {{ label }}
  </Badge>
</template>

<script setup>
import { computed } from 'vue';
import Badge from './Badge.vue';

const props = defineProps({
  bool: {
    type: Boolean,
    required: true,
  },
});

const status = computed(() => props.bool ? 'success' : 'danger');
const label = computed(() => props.bool ? 'Yes' : 'No');
</script>
